import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { StatisticCardProps } from '@/types';
import { Info } from 'lucide-react';

function StatisticCard({ isLoading, children, title, bgColor, tooltip }: StatisticCardProps) {
  if (isLoading) {
    return <Skeleton className="w-full h-40 rounded-2xl" />;
  }

  return (
    <div
      style={{ backgroundColor: bgColor }}
      className={cn(
        'flex flex-col w-full h-40 py-5 px-7 justify-between text-white rounded-2xl',
        !bgColor && 'bg-slate-500',
      )}
    >
      <div className="flex items-center gap-1.5">
        <h4 className="font-medium">{title}</h4>
        {tooltip && (
          <TooltipProvider>
            <Tooltip delayDuration={0}>
              <TooltipTrigger asChild className="cursor-help">
                <Info size={14} className="opacity-70 hover:opacity-100 transition-opacity" />
              </TooltipTrigger>
              <TooltipContent className="max-w-[220px]">
                <p className="text-xs">{tooltip}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <span className="text-4xl font-semibold">{children}</span>
    </div>
  );
}

export default StatisticCard;
